<template>
  <div v-if="value">
    <badge-list
      :value="uniq([displayText, ...additionalTokens])"
      badge-class="h-5 max-w-56 truncate text-xxs leading-4 font-semibold uppercase"
      pill-class="h-5"
      :show-num-of-items="10"
    />
    <span
      v-if="showExpandButton && !isLoading"
      v-tooltip="t('COMMON.LOAD_MORE')"
      class="ml-1 cursor-pointer hover:text-blue-500"
      @click="handleExpand"
    >
      &hellip;
    </span>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import uniq from "lodash/uniq";

import { usePromiseWrapper } from "@/hooks/common";
import clientsApiService from "@/services/modules/clients";

import BadgeList from "@/components/ui/BadgeList.vue";

import type { IApplication } from "@/models/applications";

const { value = "", model } = defineProps<{
  value?: string;
  model?: IApplication;
}>();

const { t } = useI18n();
const additionalTokens = ref<string[]>([]);
const hasLoaded = ref(false);
const isExpanded = ref(false);

const { loading: isLoading, fetchWrapper } = usePromiseWrapper(async () => {
  if (!model?.id) return;

  const response = await clientsApiService.getAdditionalTrackingTokens({
    application_ids: [model.id],
  });

  additionalTokens.value =
    response.data?.map((item: { token: string }) => item.token) || [];
  hasLoaded.value = true;
  isExpanded.value = true;
});

const showExpandButton = computed(() => {
  return !hasLoaded.value && !isExpanded.value && model?.id;
});

const displayText = computed(() => {
  if (isLoading.value) {
    return `${value} (${t("COMMON.LOADING_SERVICE").toLowerCase()})`;
  }
  return value;
});

const handleExpand = () => {
  if (hasLoaded.value || !model?.id) {
    return;
  }
  fetchWrapper();
};
</script>
